module.exports = __webpack_public_path__ + "/c563ac03accfe05666530033b7a2ccf0.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/assets/approval_icon.svg
 ** module id = 1657
 ** module chunks = 0
 **/